'use client';
import { useEffect } from 'react';

 import Header from'@/components/common/Header';
 import Footer from'@/components/common/Footer';
 import HeroSection from'./components/HeroSection';
 import ProductCategoriesSection from'./components/ProductCategoriesSection';
 import WhyChooseSection from'./components/WhyChooseSection';
 import FeaturedTestimonialsSection from'./components/FeaturedTestimonialsSection';
 import LatestBlogSection from'./components/LatestBlogSection';
 import CTABannerSection from'./components/CTABannerSection';

export default function Homepage() {
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal')
    if (!reveals.length) return

    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => e.isIntersecting && e.target.classList.add('active')),
      { threshold: 0.1 }
    )
    reveals.forEach(el => observer.observe(el))

    return () => observer.disconnect()
  }, [])

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <ProductCategoriesSection />
        <WhyChooseSection />
        <FeaturedTestimonialsSection />
        <LatestBlogSection />
        <CTABannerSection />
      </main>
      <Footer />
    </div>
  )
}